import React from 'react';
import { distractions } from '../data/kit';
export function StopSearchingSection() {
  return <section className="w-full bg-brand-dark py-20 text-white lg:py-28" aria-labelledby="deja-de-buscar" data-id="element-315" data-mp="c2r96d9f1qin">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-2 lg:gap-16" data-id="element-316" data-mp="3u8niosavcfy1">
        <div data-id="element-317" data-mp="311kvgatz7p3">
          <h2 id="deja-de-buscar" className="font-display text-4xl font-black leading-tight tracking-tight sm:text-5xl" data-id="element-318" data-mp="30rqzhmo0ge4">
            Dejá de buscar la idea perfecta
          </h2>
          <p className="mt-6 text-lg text-white/80" data-id="element-319" data-mp="3p8j4j8xfnxaz">
            Existe un momento en el que investigar deja de ser aprendizaje. Y se convierte en:
          </p>
          <p className="mt-2 font-display text-3xl font-black text-cta sm:text-4xl" data-id="element-320" data-mp="3bf9vxahb7fti">Procrastinación.</p>
        </div>

        <div data-id="element-321" data-mp="31j6uy7y71n85">
          <ul className="space-y-1" aria-label="El ciclo de la procrastinación" data-id="element-322" data-mp="31jgo24ejcai2">
            {distractions.map((item, i) => <li key={item} className="font-display text-2xl font-bold sm:text-3xl" style={{
            opacity: 1 - i * 0.15
          }} data-id="element-323" data-mp="36h8d8qnspiik" data-mpi={i}>
                {item}
              </li>)}
          </ul>
          <p className="mt-6 text-white/70" data-id="element-324" data-mp="24gdp1legqope">Mientras tanto:</p>
          <p className="font-display text-2xl font-black" data-id="element-325" data-mp="24fu7i5sq62bw">No empezás ninguno.</p>

          <div className="mt-10 border-t border-white/15 pt-8" data-id="element-326" data-mp="20ftpycabxb0m">
            <p className="text-white/80" data-id="element-327" data-mp="1coy3zvsk1a1a">Kit Ingresos Online fue diseñado para cortar ese ciclo.</p>
            <p className="mt-3 font-display text-2xl font-black sm:text-3xl" data-id="element-328" data-mp="17qd5c0syayey">
              Tenés tres caminos. <span className="text-cta" data-id="element-329" data-mp="1lh9kaotyfh3j">Elegí uno. Y empezá.</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}